import * as E from './errors';
export class DateWrapper {
	wrappedDate : Date;
	/*
		#Add or substract specified value
	*/
	manipulate(type : DateWrapper.TManipulation, value : number) {
		if (Number.isInteger(value) === false) {
			throw E.user(
				'DateWrapper.manipulate: @value: Must be a an integer!',
				{
					self  : this,
					value : value
				}
			);
		}
		var p = null;
		switch (type) {
			case 'years': {
				p = 'UTCFullYear';
			} break;
			case 'months': {
				p = 'UTCMonth';
			} break;
			case 'days': {
				p = 'UTCDate';
			} break;
			case 'hours': {
				p = 'UTCHours';
			} break;
			case 'minutes': {
				p = 'UTCMinutes';
			} break;
			case 'seconds': {
				p = 'UTCSeconds';
			} break;
			case 'milliseconds': {
				p = 'UTCMilliseconds';
			} break;
			default: {
				throw E.user(
					(
						'DateWrapper.manipulate: @type: Must be a string included in ' +
						"['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'milliseconds']!"
					),
					{
						self : this,
						type : type
					}
				);
			}
		}
		var currentValue = (<any>this.wrappedDate)['get' + p]();
		var newValue = currentValue + value;
		(<any>this.wrappedDate)['set' + p](newValue);
		return (this);
	};
	toString() {
		return (this.wrappedDate.toISOString());
	};
	getWrappedDate() {
		return (this.wrappedDate);
	};
	constructor(date : Date = new Date) {
		this.wrappedDate = date;
	};
};
export namespace DateWrapper {
	export type TManipulation = (
		'years'   |
		'months'  |
		'days'    |
		'hours'   |
		'minutes' |
		'seconds' |
		'milliseconds'
	);
};
